
import { Generic } from "./generic";

export class Cultura extends Generic {
    id: string;
    dscultura: string;
    dtatualizacao: string;
}